import { FormOptions } from 'types/forms';

const sortOptions = (options: FormOptions) =>
  Object.entries(options).sort((a, b) => ((a[1].sequence || 0) < (b[1].sequence || 0) ? -1 : 1));

export default sortOptions;
